export default [
  /** type 是為了判斷現行管理費狀態 :
   * 管理費(default-management => 原始管理費流程)(management => 來自開管理費專戶選擇頁的管理費)
   *    管理費需要兩個type 是因為需要特別去判斷他路由上一頁的設定，當社區管理費 v3 轉 v4（v3無法關閉），
   *    後端會認定兩種都有開而進 ManagementControl 頁 再根據API跳轉到V4 頁面
   *    但使用體驗上回上一頁不應該回到 ManagementControl，因此需兩種type去控制路由的prev
   * 其他費用(other-management)
   * （之後可能會有其他種type)
   **/
  {
    path: '/fee',
    redirect: '/fee/default-management'
  },
  {
    path: '/fee/:type',
    component: () => import('@/components/Layer.vue'),
    beforeEnter: (to, from, next) => {
      if (!to.params.type) {
        // 如果缺少 type 代表我目前只使用管理費為收費，因此導向管理費type
        next({ path: '/fee/default-management' })
      } else {
        next()
      }
    },
    children: [
      {
        path: '',
        component: () => import('@/views/ManagementFee/FeeMain.vue'),
        children: [
          {
            path: '',
            redirect: { name: 'FeePeriodList' }
          },
          {
            path: 'period',
            name: 'FeePeriodList',
            component: () => import('@/views/ManagementFee/FeePeriodList.vue'),
            meta: {
              prev: 'goHome',
              header: 'management'
            }
          },
          {
            path: 'payment/:id?',
            name: 'FeePaymentList',
            component: () => import('@/views/ManagementFee/FeePaymentList.vue'),
            meta: {
              prev: 'goHome',
              header: 'management'
            }
          },
          {
            path: 'deposit',
            name: 'FeeDeposit',
            component: () => import('@/views/ManagementFee/FeeDeposit.vue'),
            meta: {
              prev: 'goHome',
              header: 'management'
            }
          },
          {
            path: 'writeoff',
            name: 'FeeWriteoff',
            component: () => import('@/views/ManagementFee/FeeWriteoff.vue'),
            meta: {
              prev: 'goHome',
              header: 'management'
            }
          },
          {
            path: 'writeofferr',
            name: 'FeeWriteoffErr',
            component: () => import('@/views/ManagementFee/FeeWriteoffErr.vue'),
            meta: {
              prev: 'goHome',
              header: 'management'
            }
          },
          {
            path: 'reconcile',
            name: 'FeeReconcile',
            component: () => import('@/views/ManagementFee/FeeReconcile.vue'),
            meta: {
              prev: 'goHome',
              header: 'management'
            }
          }
        ]
      },
      {
        path: 'detail/:bulkid/:billid',
        name: 'FeeDetailEdit',
        component: () => import('@/views/ManagementFee/FeeDetailEdit.vue'),
        meta: {
          prev: 'FeePeriodList',
          header: 'management'
        }
      },
      {
        path: 'print-bill-preview',
        name: 'PrintBillPreview',
        component: () => import('@/views/ManagementFee/PrintBillPreview.vue'),
        meta: {
          header: 'none',
          footer: 'none',
          logoutinfo: 'none'
        }
      },
      {
        path: 'print-receipt-preview',
        name: 'PrintReceiptPreview',
        component: () => import('@/views/ManagementFee/PrintReceiptPreview.vue'),
        meta: {
          header: 'none',
          footer: 'none',
          logoutinfo: 'none'
        }
      }
    ]
  }

]
